'use client';

import React, { useState, useRef } from 'react';
import styles from './landingPage.module.scss';
import GameButton from '../GameButton/GameButton';
import { useRouter } from 'next/navigation';
import usePlayAudio from '@/hooks/usePlayAudio';

export const LandingPage = () => {
  const router = useRouter();

  const navigateToMap = () => {
    router.push('/interactive-map');
  };

  usePlayAudio({
    url: 'https://asthma-staging-public-storage.s3.ca-central-1.amazonaws.com/audio/bgm_intro.mp3',
    loop: true
  });

  return (
    <div className={styles.screen}>
      <div className={styles.pageContainer}>
        <div className={styles.exploreTextContainer}>
          <p className={styles.titleText}>Suit up for Mission: Breathe!</p>
          <p className={styles.subtitleText}>
            Blast off and help your space buddies breathe easy!
          </p>
        </div>
        <GameButton
          title="Start Mission"
          colorScheme="primary"
          size={'small'}
          onClick={navigateToMap}
        />
      </div>
    </div>
  );
};

export default LandingPage;
